// const ON_CHANGE_DEBOUNCE_TIMER = 300;

// const PUB_SUB_EVENTS = {
//   cartUpdate: 'cart-update',
//   quantityUpdate: 'quantity-update',
//   optionValueSelectionChange: 'option-value-selection-change',
//   variantChange: 'variant-change',
//   cartError: 'cart-error',
// };

const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
  faceSizeSelection: 'face-size-selection',
  startTryOn: 'start-try-on',
  searchSubmit: 'search-submit',
  accountCreated: 'account-created',
  VMMVAvailability: 'vmmv-availability',
  VMMVAddToCart: 'vmmv-add-to-cart',
  monogramApplied: 'monogram-applied',
  monogramRemoved: 'monogram-removed',
  updateWishlist: 'update-wishlist',
  wishlistLoaded: 'wishlist-loaded',
  wishlistCollectionItemAdded: 'wishlist-collection-item-added',
  wishlistCollectionItemRemoved: 'wishlist-collection-item-removed',
  customerWishlistCollectionItemAdded: 'customer-wishlist-collection-item-added',
  customerWishlistCollectionItemRemoved: 'customer-wishlist-collection-item-removed',
  wishlistProductItemAdded: 'wishlist-product-item-added',
  wishlistProductItemRemoved: 'wishlist-product-item-removed',
  customerWishlistProductItemAdded: 'customer-wishlist-product-item-added',
  customerWishlistProductItemRemoved: 'customer-wishlist-product-item-removed'
};

const WISHLIST_CONSTANTS = {
  localStorageKey: 'wishlist',
  eventKeyAdd: 'add',
  eventKeyRemove: 'remove'
}
